<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni

  This file MainNavigationSideNavListItem.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  MainNavigationSideNavListItem.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: MainNavigationSideNavListItem 
 Created by keni.
 with: IntelliJ IDEA
 Date: 20/07/2018
 Time: 14:19
------------------------------------------------------------------------------->
<template>
    <div>
        <a class="collapsible-header waves-effect"
                :title="title"
                :href="'/'+page_route"
        >
            <div class=" d-flex justify-content-start align-items-center ">
                <i v-if="(icon !== null) && icon.hasOwnProperty('value')"
                        class="fs-6"
                        :class="getIconClass()"
                        aria-hidden="true"
                >{{getIcon()}}</i>
                <div class="d-flex align-items-center">{{title}}
                    <!--<i class="material-icons ml-3 icon-scale-hover" aria-hidden="true">chevron_right</i>-->
                </div>
            </div>
            <!--{{log(page)}}-->
        </a>
    </div>
</template>

<script>
	// import {TweenMax, TweenLite} from 'gsap'

	export default {
		name: "main-navigation-side-nav-list-item",
		components: {},
		props: {
			page_route: String,
			title: String,
			name: String,
			icon: Object
		},
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {
			getIcon() {
				let self = this;
				if (self.icon === null) {
					return '';
				}
				if (self.icon.hasOwnProperty('value')) {
					switch (self.icon.type) {
						case 'icomoon':
							return '';
						case 'material':
							return self.icon.value;
					}
				}
				return '';
			},
			getIconClass() {
				let self = this,
					iconClass = 'material-icons';
				if (self.icon === null) {
					return '';
				}
// console.log('getIconClass', 'self.icon',self.icon);
				if (self.icon.hasOwnProperty('value')) {

					switch (self.icon.type) {
						case 'icomoon':
							return self.icon.value;

							break;
					}

				}
				return iconClass;
			}
		},
		watch: {
			icon(item) {
				console.log('icon', 'item', item);
			}
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigationSideNavListItem.vue